/**
 * @description
 * Popin with content en dom add button with data attribute equal of the id's popin.
 *
 * @param {object} options
 * @param {function} options.beforeOpen trig before popin animation
 * @param {function} options.afterOpen trig after popin animation
 * @param {function} options.beforeClose trig before close popin
 * @param {function} options.afterClose trig after close popin animation
 *
 * @method close close popin
 *
 */

const Popin = function (options) {
    const beforeOpen = options.beforeOpen || function () { };
    const afterOpen = options.afterOpen || function () { };
    const beforeClose = options.beforeClose || function () { };
    const afterClose = options.afterClose || function () { };
    const closeOutsiteAction = (typeof options.closeOutsiteAction === 'boolean') ? options.closeOutsiteAction : true;


    const popin = document.querySelector(`#${options.id}`);
    const root = document.documentElement || window;
    const clicktouch = 'ontouchstart' in root ? 'touchstart' : 'click';
    const popin_box = popin.querySelector('.popin-box');
    const btn_close = popin.querySelector('.popin-close');
    // popin.appendChild(btn_close);

    const open = () => {
        document.querySelector('body').classList.add('oh');
        popin.classList.add('open');
        popin.addEventListener('animationend', () => window.addEventListener(clicktouch, clickoutside), { once: true });
        popin.addEventListener('animationend', () => afterOpen(), { once: true });
        beforeOpen();
        document.addEventListener('keyup', escape);
    };

    const remove = () => {
        document.querySelector('body').classList.remove('oh');
        popin.classList.remove('close');
        popin.classList.remove('open');
        afterClose();
    };

    const clickoutside = e => {
        if (closeOutsiteAction === true) {
            if (!popin_box.contains(e.target) && !btn_close.contains(e.target)) close();
        }
    };

    const close = () => {
        popin.classList.add('close');
        document.removeEventListener('keyup', escape);
        beforeClose();
        window.removeEventListener(clicktouch, clickoutside, false);
        popin.addEventListener('animationend', () => remove(), { once: true });
    };

    const escape = (event) => {
        if (event.key === 'Escape') {
            close();
        }
    };

    btn_close.onclick = () => close();

    // this.close = () => close();

    open();
};

export default Popin;
